// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"ToggleButton_toggleButton__1Y1Ej"};